module.exports = __webpack_public_path__ + "img/icon-custom-remove.655b83f5.svg";